import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

Vue.use(Vuex)

const state = {
  user: {
    name: '',
    uuid: '',
    token: '',
    schoolName: '',
    balances: 0 // 账户余额
  }, // 当前用户信息及用户token
  role: null, // 当前角色信息
  excludedComponents: ['thesisOnlineReview', 'matchExpert', 'matchUnit', 'batchMatchExpert', 'batchMatchUnit', 'viewer', 'templateOfReview', 'applyCash', 'thesis'], // 不缓存页面
  permission: [], // 当前用户权限
  mapPermission: {}, // 当前url是否有权限
  pagePermission: {}, // 当前页面的按钮全选
  loginStatus: true, // 用户登录状态
  loginErrorMsg: '', // 登录错误信息
  dialogErrorMessage: {
    show: false,
    errorUrl: '',
    content: '错误内容'
  }, // 请求错误信息弹窗的内容
  headerUserMsgFlag: false // header中的个人信息页是否打开
}

let store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js